














































import { Component, Mixins } from "vue-property-decorator";
import { DepartmentGroup } from "../../../domain/department";
import { SelectorDialogMixin } from "../../system/dialogs/mixins";
import { ISingleSelectableAsynchronously } from "../../system/selectors";
import DepartmentGroupListSelector from "../selectors/DepartmentGroupListSelector.vue";

@Component({
  components: {
    DepartmentGroupListSelector,
  },
})
export default class DepartmentGroupListSelectorDialog extends Mixins(SelectorDialogMixin) implements ISingleSelectableAsynchronously<DepartmentGroup> {
  get name(): string {
    return this.$wording.common.departmentGroup;
  }

  get title(): string {
    return this.name + "選択";
  }

  async selectOption(defaultOption?: DepartmentGroup): Promise<DepartmentGroup> {
    return this.show<DepartmentGroup>(defaultOption);
  }
}
